/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

import { Button, Icon } from '..';

const Confirm = (props) => (
  <>
    {props.visible && (
      <div className="confirm" onClick={props.onClose}>
        <div className="confirm_container" onClick={(e) => e.stopPropagation()}>
          <div className="confirm_header">
            <h2>
              {props.title}
            </h2>
            <button type="button" onClick={props.onClose}>
              <Icon name="clear" width="1.5em" height="1.5em" />
            </button>
          </div>
          <div className="confirm_text">
            {props.subtitle}
          </div>
          <div className="confirm_buttons">
            <Button 
              value="Submit" 
              onClick={props.onSubmit} 
              loading={props.loading}
            />
            <Button 
              value="Cancel"
              onClick={props.onClose}
              type="secondary"
              disabled={props.loading}
            />
          </div>
        </div>
      </div>
    )}
  </>
);

Confirm.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  loading: PropTypes.bool,
};
Confirm.defaultProps = {
  title: '',
  subtitle: '',
  onSubmit: () => {},
  onClose: () => {},
  loading: false,
};

export default Confirm;